// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2AX4d","title":"Images90_title__b9FUi","images":"Images90_images__d68PC"};